import { Box, Image, Text, Container, Flex } from "@chakra-ui/react";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";
// import { small-add } from "@chakra-ui/core";
const Banner = () => {
  return (
    <Box id="premio" bg="#F5B241" py={16}>
      <TitleSpoleto>Prêmios</TitleSpoleto>
      {/* <SubTitle fontFamily="FiraSansRegular">
				Já mentaliza um trevo de quatro folhas,<br/> porque sorte nunca é demais.
			</SubTitle> */}
      <Text
        d={["block", null, null, "none"]}
        mt={8}
        display="block"
        pl={8}
        mx="auto"
        textAlign="left"
        color="#FCF3DB"
        fontSize="22px"
        lineHeight="24px"
        fontFamily="JosefinRegular"
      >
        Seja o artista da nossa nova <br /> coleção de pratos!
        <br />
        <br />
        <img width="30px" src="assets/images/Plus.png" alt="A cool cat." />
        <br />
      </Text>
      <Flex d={["flex", null, null, "none"]}>
        <Box w="55%" pl={8} overflow="hidden">
          <Text
            textAlign="left"
            color="#FCF3DB"
            fontSize="22px"
            lineHeight="24px"
            fontFamily="JosefinRegular"
          >
            Cartão <br /> pré-pago
          </Text>
          <Text
            textAlign="left"
            color="#FCF3DB"
            fontSize="35px"
            fontFamily="JosefinRegular"
          >
            <span className="r-s">R$</span>
            5000
          </Text>
        </Box>
        <Image
          width="55%"
          pos="relative"
          top="-75px"
          src="/assets/images/Group.png"
          objectFit="contain"
          alt="Banner"
        />
      </Flex>
      <Box d={["none", null, null, "block"]} w="100%">
        <Container maxW="container.xl" maxW="80%">
          <Text
            textAlign="left"
            color="#FCF3DB"
            fontSize={["30px", null, null, null, "48px"]}
            lineHeight="43px"
            fontFamily="JosefinRegular"
            pos="relative"
            top="60px"
          >
            Seja o artista da nossa nova <br /> coleção de pratos!
            <br />
            <br />
            <img src="assets/images/Plus.png" alt="A cool cat." />
            <br />
          </Text>
          <Flex mt={12} w="100%">
            <Box w="50%" py={10} pr="100px">
              <Text
                textAlign="left"
                color="#FCF3DB"
                fontSize={["30px", null, null, null, "48px"]}
                lineHeight="43px"
                fontFamily="JosefinRegular"
              >
                Cartão <br /> pré-pago
              </Text>
              <Text
                textAlign="left"
                color="#FCF3DB"
                fontSize={["50px", null, null, null, "72px"]}
                fontFamily="JosefinRegular"
              >
                <span className="r-s">R$</span>
                5000,00
              </Text>
            </Box>
            <Image
              w="60%"
              pos="relative"
              top="-80px"
              src="/assets/images/Frame.png"
              alt="Banner"
            />
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};
export default Banner;
